import { createFileRoute } from '@tanstack/react-router';
import { MasterWorkspaceDetailScreen } from '@/mobile/master/screens/MasterWorkspaceDetailScreen';

export const Route = createFileRoute('/m/master/workspaces/$id')({
  component: MasterWorkspaceDetailScreen,
});
